export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESSFUL = 'USER_LOGIN_SUCCESSFUL';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';

export const USER_UPDATE_PROFILE = 'USER_UPDATE_PROFILE';
export const USER_UPDATE_PROFILE_SUCCESSFUL = 'USER_UPDATE_PROFILE_SUCCESSFUL';
export const USER_UPDATE_PROFILE_FAILURE = 'USER_UPDATE_PROFILE_FAILURE';

export const USER_RESET_FORM_STATE = 'USER_RESET_FORM_STATE';
